import { useMemo } from 'react';
import TagManager from 'react-gtm-module';
import AppRoute from './appRoute/AppRoute';
import useMyTheme from './hooks/useMyTheme';
import { BrowserRouter } from 'react-router-dom';
import GTMRouteListener from './GTMRouteListener';
import { App as AntdApp, ConfigProvider } from 'antd';
import themeDarkConfig from './theme/themeDarkConfig';
import themeLightConfig from './theme/themeLightConfig';
import { NotificationProvider } from './utils/UtilNotify';
import colors from './styles/Color.scss';
import 'antd/dist/reset.css';
import './styles/App.scss';

const REQUIRED_STAR_STYLE = { color: colors.redColor, marginLeft: 4 };

const FORM_CONFIG = {
  colon: false,
  requiredMark: (label, { required }) => (
    <>
      {label}
      {required && <span style={REQUIRED_STAR_STYLE}>*</span>}
    </>
  ),
};

function App() {
  const { isDark } = useMyTheme();

  const future = useMemo(
    () => ({
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }),
    []
  );

  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_TAG_MANAGER_KEY,
  };

  TagManager.initialize(tagManagerArgs);

  return (
    <ConfigProvider
      theme={isDark ? themeDarkConfig : themeLightConfig}
      form={FORM_CONFIG}
    >
      <AntdApp style={{ colorScheme: isDark ? 'dark' : 'light' }}>
        <NotificationProvider>
          <BrowserRouter future={future}>
            <GTMRouteListener />
            <AppRoute />
          </BrowserRouter>
        </NotificationProvider>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
